import _ from 'lodash'

export default function cancelPlaceOrderConfirmation(props = {}) {
  const t = _.get(props, 't')
  const onContinue = _.get(props, 'onContinue')
  const onCancel = _.get(props, 'onCancel')
  return {
    title: t('ui.cancelPlaceOrderConfirmationModal.title'),
    message: t('ui.cancelPlaceOrderConfirmationModal.description'),
    buttons: _.compact([
      {
        text: t('ui.cancelPlaceOrderConfirmationModal.buttons.continue'),
        onClick: onContinue,
      },
      {
        text: t('ui.cancelPlaceOrderConfirmationModal.buttons.cancel'),
        onClick: onCancel,
      },
    ]),
  }
}
